var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 69,
    viewBox: "0 0 60 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#tsbpiisz2a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.867 37.397a1.824 1.824 0 0 0-1.753-1.237h-1.21V14.277a3.972 3.972 0 0 0-4-3.996H14.382c-2.368 0-4.381 2.012-4.381 4.377V49.48c0 2.264 2.086 4.186 4.333 4.186h21.755c.23 0 .433.187.415.416-.018.241-.22.345-.455.345H27.38L34 58.233h15.238l-6.371-20.836zM25.247 51.8c-.609 0-1.066-.456-1.066-1.065 0-.58.487-1.066 1.067-1.066.61 0 1.066.457 1.066 1.066-.019.608-.457 1.065-1.066 1.065zm11.8-15.641h-3.742c-1.01 0-1.867.894-1.867 1.903 0 1.008.857 1.902 1.867 1.902h3.771v7.992H13.048V15.8h24v20.36zm-12.18-.429c4.706.046 8.476-3.85 8.491-8.452.047-4.701-3.738-8.452-8.46-8.482-4.722-.031-8.476 3.85-8.491 8.451-.046 4.702 3.855 8.452 8.46 8.483zm3.375-11.839c.836.047 1.447.642 1.417 1.477-.047.835-.643 1.446-1.479 1.415-.836-.046-1.447-.641-1.416-1.477.03-.835.634-1.446 1.478-1.415zm-3.344 9.535c-2.059-.016-3.9-1.214-4.837-3.21-.163-.394.046-.834.425-1.005.395-.162.836.047 1.123.464a3.777 3.777 0 0 0 3.343 2.204c1.448.031 2.702-.82 3.305-2.157.217-.44.705-.596 1.053-.41.441.216.627.61.41 1.052-.835 1.863-2.763 3.1-4.822 3.062zm-3.096-9.535c.836.047 1.448.642 1.417 1.477-.047.835-.643 1.446-1.479 1.415-.727-.015-1.447-.641-1.416-1.477.015-.726.642-1.446 1.478-1.415z",
    fill: "url(#dcb5m6oreb)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dcb5m6oreb",
    x1: 29.619,
    y1: 10.281,
    x2: 29.619,
    y2: 58.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A44E"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tsbpiisz2a",
    x: 0,
    y: 0.281,
    width: 59.238,
    height: 67.953,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.984314 0 0 0 0 0.858824 0 0 0 0 0.592157 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_121_1132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_121_1132",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.9a7cec11300b5640501a6f252fd754f9.svg";
export { ForwardRef as ReactComponent };